module.exports = __webpack_public_path__ + "img/close.fed9c2be.png";